import { createAction, props } from '@ngrx/store';
export const setFundChartSortColumn = createAction('[Fund Chart] Set Sort Column', props());
